import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import swal from 'sweetalert';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { getCartProducts, getSchool } from '../modules/reducers';
import { clearCart, updateCart } from '../modules/actions';
import { FILE_DOWNLOAD_URL } from '../Config';
import _ from 'lodash';

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartProducts: []
        }
    }
    componentDidMount() {
        this.fetchProducts();
    }
    fetchProducts() {
        this.setState({
            cartProducts: this.props.products
        })
    }
    deleteCart() {
        this.props.clearCart();
    }
    handleRemoveCartElement(item) {
        let products = this.props.products;
        let result;
        if (item.orderType === 'uniformProducts') {
            result = _.reject(products, { productSetId: item.productSetId });
        } else {
            result = _.reject(products, { languageId: item.languageId });
        }
        this.props.updateCart(result);
    }

    handleUpdateQuantity(id, action) {
        let products = this.props.products;
        products = products.map((item, index) => {
            if(item.id === id) {
                if(action === 'sub' && item.prodCount !== 1) {
                    item.prodCount = item.prodCount - 1;
                    item.pTotal = item.pTotal - item.price;
                }
                if(action === 'add') {
                    item.prodCount = item.prodCount + 1;
                    item.pTotal = item.pTotal + item.price;
                }
            }
            return item;
        })
        this.props.updateCart(products);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.products != this.props.products) {
            this.fetchProducts();
        }
    }

    handleProceedCheckout() {
        if (this.state.cartProducts.length === 0) {
            swal('Warning', 'Please add products into the cart to place the order', 'warning');
            return;
        }
        window.location.href = 'checkout';
    }
    render() {
        return (
            <div className="site-wrap">
                <Header />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><a href={`school/${this.props.school.name}`}>Home</a> <span className="mx-2 mb-0">/</span> <strong className="text-black">Cart</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row mb-5">
                            <form className="col-md-12" method="post">
                                <div className="site-blocks-table">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="product-name">Product</th>
                                                <th className="product-price">Price</th>
                                                <th className="product-remove">Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.cartProducts.length > 0 ?
                                                <>
                                                    {this.state.cartProducts.map((item, idx) => (
                                                        <tr>
                                                            <td className="product-name">
                                                                <h2 className="h5 text-black">{item.productSetName}</h2>
                                                            </td>
                                                            <td>₹{item.price}</td>
                                                            <td><a onClick={() => this.handleRemoveCartElement(item)} className="btn btn-primary btn-sm btnColor">X</a></td>
                                                        </tr>
                                                    ))}
                                                </>
                                                :
                                                <tr className='text-center'>
                                                    <td colSpan={6}>No products added in the cart</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row mb-5">
                                    <div className="col-md-6 mb-3 mb-md-0">
                                        <button className="btn btn-primary btn-sm btn-block" onClick={() => this.deleteCart()}>Delete Cart</button>
                                    </div>
                                    <div className="col-md-6">
                                        <a href={`school/${this.props.school.name}`} className="btn btn-outline-primary btn-sm btn-block">Continue Shopping</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 pl-5">
                                <div className="row justify-content-end">
                                    <div className="col-md-7">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button className="btn btn-primary btn-lg py-3 btn-block" onClick={() => this.handleProceedCheckout()}>Proceed To Checkout</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        products: getCartProducts(state),
        school: getSchool(state)
    }
}

const mapDispatchToProps = dispatch => ({
    clearCart: () => dispatch(clearCart()),
    updateCart: (products) => dispatch(updateCart(products))
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Cart);